import { render } from "./GroupManagementPermissionsDialog.vue?vue&type=template&id=7cf99146"
import script from "./js/groupManagementPermissionsDialog.js?vue&type=script&lang=js&external"
export * from "./js/groupManagementPermissionsDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__